module.exports = __webpack_public_path__ + "static/media/logo_shrinking.5873f434.png";